export * from './lib/page-structure-footer.module';
